import { useInteractiveShop } from '../../../../../redux/reducer/content';
import { background as defaultBackground } from '../../constants/background';
import { useLoadImages } from '../../../../../hooks/useLoadImages';
import getIsTruthBackground from '../../utils/getIsTruthBackground';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';

let cashedPromise;

export default function useSetBackground() {
  const { background } = useInteractiveShop();
  const { loadImages } = useLoadImages();
  const callbacks = useApplicationCallbacks();

  return (bg = defaultBackground) => {
    return (cashedPromise ??= (async () => {
      if (!background || !getIsTruthBackground(bg)) {
        const [loadedBg] = await loadImages([bg]);
        callbacks.setInteractiveShopBackground(loadedBg);
      }
    })());
  };
}
